<template>
  <div class="social-sites">
    <SocialShareIcon
      v-for="site in socialSites"
      :key="site.name"
      :icon="site.icon"
      :hovered="site.hovered"
      :hover-color="hoverColor"
      :color="color"
      class="social-site"
      @click="handleShare(site.url)"
      @mouseover="site.hovered = true"
      @mouseleave="site.hovered = false"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import SocialShareIcon from "@/components/builder/publish/social-share-icon.vue";

const props = defineProps({
  surveyFormUrl: {
    type: String,
    required: true,
  },
  hoverColor: {
    type: String,
    default: "#98A2B3",
  },
  color: {
    type: String,
    default: "#98A2B3",
  },
});

const socialSites = ref([
  {
    name: "Facebook",
    icon: "facebook",
    url: `https://www.facebook.com/sharer/sharer.php?u=${props.surveyFormUrl}`,
    hovered: false,
  },
  {
    name: "X",
    icon: "twitter",
    url: `https://twitter.com/intent/tweet?url=${props.surveyFormUrl}`,
    hovered: false,
  },
  {
    name: "Linkedin",
    icon: "linkedin",
    url: `https://www.linkedin.com/sharing/share-offsite/?url=${props.surveyFormUrl}`,
    hovered: false,
  },
  {
    name: "Email",
    icon: "email",
    url: `mailto:?subject=I wanted you to see this form&amp;body=Check out this form ${props.surveyFormUrl}`,
    hovered: false,
  },
]);

const handleShare = (url) => window.open(url, "_blank");
</script>

<style scoped>
.social-sites {
  display: flex;
  align-items: center;
  gap: 24px;
}

.social-site {
  cursor: pointer;
}
</style>
